export default "__VITE_ASSET__f7ea7c39__"